const AwardsSection = () => {
  const awards = [
    {
      year: '2026',
      title: 'Best Tech Company',
      organization: 'Tech Excellence Awards',
      description: 'Recognized for outstanding innovation and technical excellence in software development.',
    },
    {
      year: '2026',
      title: 'Top IT Service Provider',
      organization: 'Global IT Summit',
      description: 'Awarded for delivering exceptional IT services and client satisfaction worldwide.',
    },
    {
      year: '2025',
      title: 'Innovation Leader',
      organization: 'Digital Transformation Awards',
      description: 'Honored for pioneering digital solutions that transform business operations.',
    },
    {
      year: '2025',
      title: 'Excellence in Design',
      organization: 'UX Design Awards',
      description: 'Celebrated for creating intuitive and beautiful user experiences across platforms.',
    },
  ];

  return (
    <section className="relative w-full bg-background-100 border-t border-background-200 py-14 md:py-16 overflow-hidden">
      <div className="section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex w-6 h-6 items-center justify-center bg-foreground-900 text-background-50 rounded-sm">
                  <i className="ri-award-line text-xs"></i>
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-600">
                  09 / Recognition
                </span>
              </div>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight text-foreground-900 max-w-3xl">
                Awards &{' '}
                <span className="block text-primary-500">Recognition.</span>
              </h2>
            </div>
            <p className="max-w-md text-[15px] leading-relaxed text-foreground-700">
              Awarded for contributions to technology, including recognition from leading industry bodies worldwide.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {awards.map((award, index) => (
              <div
                key={index}
                className="group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200 transition-all duration-500 hover:-translate-y-1 hover:border-foreground-900/30"
              >
                <div className="w-12 h-12 bg-foreground-900 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-trophy-line text-background-50 text-xl"></i>
                </div>
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 text-primary-500 text-[10px] font-mono uppercase tracking-widest mb-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                  {award.year}
                </div>
                <h3 className="font-display text-lg font-bold text-foreground-900 mb-1">{award.title}</h3>
                <p className="text-foreground-500 text-sm mb-3">{award.organization}</p>
                <p className="text-foreground-600 text-sm leading-relaxed">{award.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;